// extracted by mini-css-extract-plugin
export default {"noiseGraf":"NoizeGraf_noiseGraf__h98Vz","noiseCanvas":"NoizeGraf_noiseCanvas__yR6LP"};